export const module1 = [
  [
    'Clase 1',
    'Proporciones y creación de la cabeza a partir de esfera',
  ],
  ['Clase 2', 'Mejoramos la cabeza y añadimos nuevas subtools'],
  [
    'Clase 3',
    'Mejoramos la cabeza, añadimos polypaint a subtools y creamos la boca',
  ],
  [
    'Clase 4',
    'Hacemos pequeños ajustes y comenzamos con torso y brazos',
  ],
  [
    'Clase 5',
    'Creamos las piernas, combinamos subtools del cuerpo y mejoramos la pose',
  ],
  ['Clase 6', 'Creamos las manos y mejoramos el cuerpo'],
  [
    'Clase 7',
    'Comparamos proporciones, pequeños ajustes y creamos los piercings',
  ],
  ['Clase 8', 'Comparamos proporciones y empezamos con el chaleco'],
  ['Clase 9', 'Hacemos correcciones'],
  ['Clase 11', 'Mejoramos la chaqueta'],
  ['Clase 10', 'Creamos la chaqueta'],
];

export const module2 = [
  ['Clase 13', 'Mejoramos el pantalón y creamos rodillera'],
  [
    'Clase 14',
    'Creamos el cinturón con ayuda de Zmodeler y las trabillas',
  ],
  ['Clase 15', 'Empezamos a crear las botas'],
  [
    'Clase 16',
    'Mejoramos las botas y aprendemos a crear pincel InsertMesh',
  ],
  [
    'Clase 17',
    'Añadimos cuerdas a las botas y terminamos de mejorarlas',
  ],
  ['Clase 18', 'Creamos los guantes'],
  ['Clase 19', 'Mejoramos el chaleco'],
  ['Clase 20', 'Mejoramos las subtools y arreglamos fallos'],
  ['Clase 12', 'Empezamos con el pantalón'],
  ['Clase 21', 'Creamos Asimetrías en la chaqueta'],
  ['Clase 22', 'Mejoramos chaqueta y creamos las vendas del brazo'],
];

export const module3 = [
  ['Clase 23', 'Creamos los cocteles molotov'],
  ['Clase 24', 'Creamos los enganches de las botellas'],
  ['Clase 25', 'Comenzamos con el lanzallamas'],
  ['Clase 26', 'Continuamos con el lanzallamas'],
  ['Clase 27', 'ArrayMesh y continuamos con el lanzallamas'],
  ['Clase 28', 'Creamos la empuñadura del lanzallmas'],
  ['Clase 29', 'Creamos el gatillo y el encendedor de lanzallamas'],
  ['Clase 30', 'Mejoramos el lanzallamas con detalles'],
  [
    'Clase 31',
    'Terminamos el lanzallamas, hacemos booleanas y creamos uv’s para usar el ruido-noise',
  ],
  ['Clase 32', 'Empezamos con las bombonas-Jetpack'],
  ['Clase 33', 'Continuamos con las bombonas-Jetpack'],
  ['Clase 34', 'Finalizamos con las bombonas-Jetpack'],
];